export default "__VITE_ASSET__BoSi1zDo__"